module.exports = __webpack_public_path__ + "img/in_icon-w-01.9eec0d1b.svg";